import useSWR from 'swr';

import { fetcherWithToken } from './ApiClient';
import { NotificationsRequest } from './types/NotificationTypes';

export const useNotifications = (req: NotificationsRequest) => {
  const shouldFetch = !!req.userId && !!req.userToken;

  const params = `page[number]=${req.page}`;

  const { data, error, isLoading } = useSWR(
    shouldFetch ? [`${process.env.REACT_APP_DOMAIN}/api/notifications?${params}`, req.userToken] : null,
    ([url, token]) => fetcherWithToken(url, token),
    {
      revalidateIfStale: false,
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
    });

  return {
    data: data,
    isLoading: isLoading,
    isError: error
  }
};